import { createI18n } from 'vue-i18n'
import messages from '@/i18n/messages'

const lang = localStorage.getItem('lang') || 'tr'

const i18n = createI18n({
  locale: lang,
  fallbackLocale: 'tr',
  legacy: false,
  messages
})

export default i18n